import {
  STORE_CSID,
  STORE_DeliveryZoneID,
  STORE_DineType,
  STORE_MTYPE,
  STORE_MobileAppCategory,
  STORE_NIC,
  STORE_SelectedMerchantProduct,
  STORE_PhoneNo,
  STORE_ZoneDescription,
  STORE_ZoneId,
  STORE_dtoMobileSettings,
  STORE_CustomerName,
  TEMP_STORE_CustomerName,
  TEMP_STORE_CSID,
  TEMP_STORE_PhoneNo,
  STORE_dtoCustomerAddressList,
  STORE_CustomerDefaultAddress,
  STORE_Cart,
  STORE_FinaleSelelctCartMerchantNZone,
  STORE_Addons,
  STORE_CartCheckoutData,
  TEMP_STORE_OTP,
  STORE_StartingNo,
  STORE_CSP,
  STORE_PAGE_URL,
} from "./store-names";
import {
  dto_CustomerAddressList,
  dto_CustomerAddress,
} from "../classes/dto-customer";
import { dto_selected_merchant_or_product } from "../classes/dto-selected-merchant-or-product";
import { dto_StartupPageLoadInfo } from "../classes/dto-mobile-settings";
import { dto_MobileAppCategory } from "../classes/dto-mobile-app-category";
import { ENCRYPT_STORAGE } from "../config/config";
import {
  encryptCartStorageData,
  encryptCheckoutStorageData,
} from "../functions/store_sessions";

let cartMemoryCache;
let cartMemoryCacheReady = false;

export const GET_CART_MEMORY_CACHE = () =>
  cartMemoryCacheReady ? cartMemoryCache : undefined;

export const SET_CART_MEMORY_CACHE = (data) => {
  cartMemoryCache = Array.isArray(data) ? [...data] : data;
  cartMemoryCacheReady = true;
};

export const CLEAR_CART_MEMORY_CACHE = () => {
  cartMemoryCache = [];
  cartMemoryCacheReady = true;
};

//#region DEFAULT_CONFIG
export const SET_STORE_DEFAULT_CONFIG = async (
  ZoneId,
  ZoneDescription,
  DeliveryZoneID,
  MTYPE
) => {
  if (ENCRYPT_STORAGE.getItem(STORE_ZoneId) === undefined) {
    ENCRYPT_STORAGE.setItem(STORE_ZoneId, ZoneId);
    ENCRYPT_STORAGE.setItem(STORE_ZoneDescription, ZoneDescription);
  }
  if (ENCRYPT_STORAGE.getItem(STORE_CSID) === undefined) {
    ENCRYPT_STORAGE.setItem(STORE_CSID, 0);
  }
  if (ENCRYPT_STORAGE.getItem(STORE_NIC) === undefined) {
    ENCRYPT_STORAGE.setItem(STORE_NIC, 0);
  }

  if (ENCRYPT_STORAGE.getItem(STORE_DeliveryZoneID) === undefined) {
    ENCRYPT_STORAGE.setItem(STORE_DeliveryZoneID, DeliveryZoneID);
    //await SET_STORE_DELIVERYZONEID(DeliveryZoneID);
  }
  if (ENCRYPT_STORAGE.getItem(STORE_DeliveryZoneID) === "undefined") {
    ENCRYPT_STORAGE.setItem(STORE_DeliveryZoneID, DeliveryZoneID);
    //await SET_STORE_DELIVERYZONEID(DeliveryZoneID);
  }
  ENCRYPT_STORAGE.setItem(STORE_MTYPE, MTYPE);
};
//#endregion

//#region MOBILE_SETTINGS
export const SET_STORE_MOBILE_SETTINGS = async () => {
  ENCRYPT_STORAGE.setItem(STORE_dtoMobileSettings, dto_StartupPageLoadInfo);
};
//#endregion

//#region DINE_TYPE
export const SET_STORE_DINE_TYPE = async (value) => {
  ENCRYPT_STORAGE.setItem(STORE_DineType, value);
};
//#endregion

//#region SELECTED_MERCHANT_OR_PRODUCT
export const SET_STORE_SELECTED_MERCHANT_PRODUCT = async () => {
  ENCRYPT_STORAGE.setItem(
    STORE_SelectedMerchantProduct,
    dto_selected_merchant_or_product
  );
};
//#endregion

//#region STORE_MOBILE_APP_CATEGORY
export const SET_STORE_MOBILE_APP_CATEGORY = async () => {
  ENCRYPT_STORAGE.setItem(STORE_MobileAppCategory, dto_MobileAppCategory);
};
//#endregion

//#region CSID
export const SET_STORE_CSID = async (CSID) => {
  ENCRYPT_STORAGE.setItem(STORE_CSID, CSID);
};
//#endregion

//#region PHONE_NO
export const SET_STORE_PHONE_NO = async (PhoneNo) => {
  ENCRYPT_STORAGE.setItem(STORE_PhoneNo, PhoneNo);
};
//#endregion

//#region CUSTOMER_NAME
export const SET_STORE_CUSTOMER_NAME = async (CustomerName) => {
  ENCRYPT_STORAGE.setItem(STORE_CustomerName, CustomerName);
};
//#endregion

//#region CUSTOMER_ADDRESS LIST
export const SET_STORE_CUSTOMER_ADDRESSLIST = async () => {
  ENCRYPT_STORAGE.setItem(
    STORE_dtoCustomerAddressList,
    dto_CustomerAddressList
  );
};
//#endregion

//#region TEMP_PHONE_NO
export const SET_STORE_TEMP_STORE_PHONE_NO = async (TempPhoneNo) => {
  ENCRYPT_STORAGE.setItem(TEMP_STORE_PhoneNo, TempPhoneNo);
};
//#endregion

//#region TEMP_CUSTOMER_NAME
export const SET_STORE_TEMP_STORE_CUSTOMER_NAME = async (CustomerName) => {
  ENCRYPT_STORAGE.setItem(TEMP_STORE_CustomerName, CustomerName);
};
//#endregion

//#region TEMP_CSID
export const SET_STORE_TEMP_FUN_STORE_CSID = async (CSID) => {
  ENCRYPT_STORAGE.setItem(TEMP_STORE_CSID, CSID);
};
//#endregion

//#region TEMP_STORE_OTP
export const SET_STORE_TEMP_STORE_OTP = async (OTP) => {
  ENCRYPT_STORAGE.setItem(TEMP_STORE_OTP, OTP);
};
//#endregion

//#region C A R T
export const SET_STORE_CART = async (data) => {
  SET_CART_MEMORY_CACHE(data);
  window.setTimeout(() => {
    ENCRYPT_STORAGE.setItem(STORE_Cart, encryptCartStorageData(data));
  }, 0);
};
//#endregion

//#region SET_STORE_ADDONUOM
export const SET_STORE_ADDONUOM = async (data) => {
  ENCRYPT_STORAGE.setItem(STORE_Addons, data);
};
//#endregion

//#region SET_STORE_PROMOTIONS
export const SET_STORE_PROMOTIONS = async (data) => {
  ENCRYPT_STORAGE.setItem(STORE_Addons, data);
};
//#endregion

//#region SET_STORE_CART_CHECKOUT_DATA
export const SET_STORE_CART_CHECKOUT_DATA = async (data) => {
  ENCRYPT_STORAGE.setItem(
    STORE_CartCheckoutData,
    encryptCheckoutStorageData(data),
  );
};
//#endregion

//#region SET_STORE_CART_SELECT_MERCHATS_ZONE
export const SET_STORE_CART_SELECT_MERCHATS_ZONE = async (data) => {
  ENCRYPT_STORAGE.setItem(STORE_FinaleSelelctCartMerchantNZone, data);
};
//#endregion

//#region CUSTOMER_ADDRESS1
export const SET_STORE_CUSTOMER_DEFAULT_ADDRESS = async () => {
  ENCRYPT_STORAGE.setItem(STORE_CustomerDefaultAddress, dto_CustomerAddress);
};
//#endregion

//#region TEMP_STORE_OTP
export const SET_STORE_DELIVERYZONEID = async (DeliveryZoneID) => {
  ENCRYPT_STORAGE.setItem(STORE_DeliveryZoneID, DeliveryZoneID);
};
//#endregion

//#region STARTING_NO
export const SET_STORE_ZONEID = async (ZoneID) => {
  ENCRYPT_STORAGE.setItem(STORE_ZoneId, ZoneID);
};
//#endregion

//#region STARTING_NO
export const SET_STORE_DELIVERY_ZONE_DESCRIPTION = async (ZoneDesc) => {
  ENCRYPT_STORAGE.setItem(STORE_ZoneDescription, ZoneDesc);
};
//#endregion

//#region STARTING_NO
export const SET_STORE_STARTING_NO = async (StartingNo) => {
  ENCRYPT_STORAGE.setItem(STORE_StartingNo, StartingNo);
};
//#endregion

//#region STARTING_NO
export const SET_STORE_CSP = async (CSP) => {
  ENCRYPT_STORAGE.setItem(STORE_CSP, CSP);
};
//#endregion

//#region PAGE_URL
export const SET_STORE_PAGE_URL = async (URL) => {
  ENCRYPT_STORAGE.setItem(STORE_PAGE_URL, URL);
};
//#endregion
